import React from "react";
import { Route, Routes } from "react-router-dom";

import Layout from "./components/Layout/Layout";

import HomeScreen from "./pages/HomeScreen/HomeScreen";
import PracticeSearch from "./pages/PracticeSearch/PracticeSearch";
import PracticeProfile from "./pages/PracticeProfile/PracticeProfile";
import ProviderSearch from "./pages/ProviderSearch/ProviderSearch";
import ProviderProfile from "./pages/ProviderProfile/ProviderProfile";
import Report from "./pages/Reports/ReportNav"; 
import ReportOnlineScheduling from "./pages/Reports/OnlineScheduling"; 

const App = () => (
	<Layout>
		<Routes>
			<Route path="/" element={<HomeScreen />} />
			<Route path="/providers" element={<ProviderSearch />} />
			<Route path="/providers/:id/*" element={<ProviderProfile />} /> 
			<Route path="/practices" element={<PracticeSearch />} />
			<Route path="/practices/:id" element={<PracticeProfile />} />
			<Route path="/report" element={<Report />} />
			<Route path="/report/onlineScheduling" element={<ReportOnlineScheduling />} />
		</Routes>
	</Layout>
);

export default App;